export default function(
  state = {
    surveyDetails: {},
    learningTasks: [],
    doingTasks: [],
    hasRetrievedLearingTasks: false,
    hasRetrievedDoingTasks: false,
    loading: false,
    activeSurveyId: null,
  },
  action,
) {
  switch (action.type) {
    case 'SURVEY/POPULATE_SURVEY_DETAILS':
      return { ...state, surveyDetails: action.surveyDetails };
    case 'SURVEY/POPULATE_LEARNING_TASKS':
      return {
        ...state,
        learningTasks: action.learningTasks,
        hasRetrievedLearingTasks: true,
      };
    case 'SURVEY/SET_LOADING':
      return {
        ...state,
        loading: action.mode,
      };
    case 'SURVEY/POPULATE_DOING_TASKS':
      return {
        ...state,
        doingTasks: action.doingTasks,
        hasRetrievedDoingTasks: true,
      };
    case 'SURVEY/SET_ACTIVE_SURVEY':
      return { ...state, activeSurveyId: action.surveyId };
    default:
      return state;
  }
}
